
export const szakacsgeri = {
  content: {
    hero: {
      title: "Szakács Geri",
      subtitle: "Énekes-dalszerző"
    },
    biography: {
      title: "Történetem"
    },
    services: {
      title: "Kapcsolódj a Zenémhez",
      subtitle: "Fedezd fel a különböző módokat, ahogyan közelebbi kapcsolatba kerülhetsz velem és a zenémmel",
      explore: "Felfedezem"
    },
    discography: {
      title: "Diszkográfia",
      tracks: "Dalok",
      listen: "Hallgasd meg"
    },
    concerts: {
      title: "Koncertek",
      subtitle: "Élőben hallani a zenét mindig különleges élmény. Nézd meg, mikor találkozhatsz velem koncerten.",
      buyTickets: "Jegyvásárlás",
      soldOut: "Telt ház",
      soon: "Hamarosan",
      noEvents: "Jelenleg nincs meghirdetett koncert. Kövess közösségi médiákon, hogy értesülj a friss hírekről!"
    },
    testimonials: {
      title: "Rólam mondták",
      subtitle: "Hallgasd meg, mit mondanak a rajongók a zenémről",
      fan: "Rajongó"
    },
    video: {
      title: "Kiemelt Videó",
      subtitle: "Nézd meg legújabb videóklipemet és merülj el a zenémben"
    },
    spotify: {
      title: "Spotify Lejátszási Listák",
      subtitle: "Hallgasd meg válogatott dalaimat és kedvenc zenéimet"
    },
    gallery: {
      title: "Galéria",
      subtitle: "Képek a koncertekről és a kulisszák mögül"
    },
    awards: {
      title: "Díjak és elismerések",
      subtitle: "Elismerések, amelyeket a zenei pályafutásom során kaptam"
    },
    influences: {
      title: "Hatások és hangszerek",
      subtitle: "Zenei hatások és hangszerek, amelyek formálták a stílusomat",
      musicalInfluences: "Zenei hatások",
      instruments: "Hangszerek"
    },
    press: {
      title: "Sajtómegjelenések",
      subtitle: "Válogatás a rólam megjelent cikkekből, interjúkból",
      readArticle: "Cikk olvasása"
    },
    quote: {
      byArtist: "Szakács Geri"
    },
    footer: {
      allRights: "Minden jog fenntartva.",
      contact: "Kapcsolat",
      follow: "Kövess"
    }
  }
};
